import styled from '@emotion/styled';
import { Grid, Typography } from '@mui/material';

import { useAppSelector } from '@/redux/hooks';
import {
  selectTitleNavigationDrawerIsSearchFulfilled,
  selectTitleNavigationDrawerIsSearching,
  selectTitleNavigationDrawerSlice
} from '@/redux/selectors/titleNavigationDrawerSelectors';
import TitlesListSkeleton from '@/components/Focus/AvailsSchedule/TitleNavigationDrawer/TitlesListSkeleton';
import TitleItem from '@/components/Focus/AvailsSchedule/TitleNavigationDrawer/TitleItem';

const TitlesList = () => {
  const { searchTerm, currentTab, titleSearchResults, recentTitles } = useAppSelector(selectTitleNavigationDrawerSlice);
  const isSearching = useAppSelector(selectTitleNavigationDrawerIsSearching);
  const isSearchFulfilled = useAppSelector(selectTitleNavigationDrawerIsSearchFulfilled);

  if (isSearching) return <TitlesListSkeleton />;

  const isNoResults = currentTab === 'all' && searchTerm.length > 0 && titleSearchResults.length === 0 && isSearchFulfilled;
  if (isNoResults) return <TitlesListNoResults>No titles found</TitlesListNoResults>;

  const titles = currentTab === 'all' ? titleSearchResults : currentTab === 'recent' ? recentTitles : [];
  return (
    <StyledGrid container>
      {titles.map((title) => (
        <TitleItem key={title.id} title={title} />
      ))}
    </StyledGrid>
  );
};

export default TitlesList;

const TitlesListNoResults = styled(Typography)(({ theme }) => ({
  flex: 1,
  display: 'flex',
  justifyContent: 'center',
  height: 80,
  color: theme.palette.text.secondary,
  paddingTop: theme.spacing(2)
}));

const StyledGrid = styled(Grid)(({ theme }) => ({
  flex: 1,
  flexWrap: 'nowrap',
  flexDirection: 'column',
  rowGap: theme.spacing(1),
  overflowY: 'auto',
  overscrollBehavior: 'contain'
}));
